// Read the logged-in user from localStorage, tolerating garbage values.
// Failed/interrupted login flows have historically written the literal
// strings "undefined"/"null" (JSON.stringify(undefined) → undefined →
// setItem coerces it), which made bare JSON.parse calls throw and blank
// the whole app. Always returns an object.
function safeUser() {
    try {
        const raw = localStorage['user'];
        if (!raw || raw === 'undefined' || raw === 'null') return {};
        return JSON.parse(raw) || {};
    } catch (e) {
        return {};
    }
}

class UserService {
    getUserId() {
        return safeUser().userId;
    }

    getUserName() {
        return safeUser().userName;
    }

    getEnquiryId() {
        return safeUser().enquiryId;
    }

    getBatchId() {
        // Get the first batch's batchId from the user's batches array
        const user = safeUser();
        if (user.batches && user.batches.length > 0) {
            return user.batches[0].batchId;
        }
        return null;
    }

    getToken() {
        return safeUser().token;
    }
}

export default new UserService();
